import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "inicio",
    component: () => import("@/layout/WebLayout.vue"),
    children: [
      {
        path: "/",
        name: "Inicio",
        component: () => import("@/views/Home.vue"),
      },
      {
        path: "/equipo-dirbde",
        name: "Equipo DIRBDE",
        component: () => import("@/views/EquipoDirbde.vue"),
      },
      {
        path: "/noticias",
        name: "Noticias",
        component: () => import("@/views/News.vue"),
      },
      {
        path: "/aplicativos",
        name: "Herramientas",
        component: () => import("@/views/Aplicativos.vue"),
      },
      {
        path: "/noticias/:slug",
        name: "Detalle de noticia",
        component: () => import("@/views/NewsDetail.vue"),
        props: true,
      },
      {
        path: "/newsletters",
        name: "Publicaciones",
        component: () => import("@/views/Newsletters.vue"),
        props: true,
      },
      {
        path: "/oauth2",
        name: "Autentificacion",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/OAuth2.vue"),
        props: true,
      },
    ],
  },
  {
    path: "/dashboard",
    redirect: "/dashboard",
    name: "dashboard",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/dashboard",
        name: "Dashboard",
        component: () => import("@/views/DashboardGral.vue"),
      },
      {
        path: "/post/:id",
        name: "Detalle de documento",
        component: () =>
          import("@/views/crafted/pages/intranet/PostDetail.vue"),
      },
      {
        path: "/beneficios-internos/arancel/buch",
        name: "Arancel - BUCH",
        component: () => import("@/views/crafted/pages/intranet/Buch.vue"),
      },
      {
        path: "/beneficios-internos/arancel/bab",
        name: "Arancel - BAB",
        component: () => import("@/views/crafted/pages/intranet/Bab.vue"),
      },
      {
        path: "/beneficios-internos/mantencion/bae",
        name: "Mantención - BAE",
        component: () => import("@/views/crafted/pages/intranet/Bae.vue"),
      },
      {
        path: "/beneficios-internos/mantencion/mbrunet",
        name: "Mantención - M. Brunet",
        component: () => import("@/views/crafted/pages/intranet/Mbrunet.vue"),
      },
      {
        path: "/beneficios-internos/mantencion/bal",
        name: "Mantención - BAL",
        component: () => import("@/views/crafted/pages/intranet/Bal.vue"),
      },
      {
        path: "/beneficios-internos/mantencion/per",
        name: "Mantención - PER",
        component: () => import("@/views/crafted/pages/intranet/Per.vue"),
      },
      {
        path: "/beneficios-internos/mantencion/beca-emergencia",
        name: "Mantención - Beca Emergencia",
        component: () =>
          import("@/views/crafted/pages/intranet/BecaEmergencia.vue"),
      },
      {
        path: "/beneficios-internos/mantencion/beca-irma-salas",
        name: "Mantención - Beca Irma Salas",
        component: () =>
          import("@/views/crafted/pages/intranet/BecaIrmaSalas.vue"),
      },
      {
        path: "/beneficios-internos/mantencion/mantencion-documentos-generales",
        name: "Mantención - Documentos Generales",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/MantencionDocumentosGenerales.vue"
          ),
      },
      {
        path: "/beneficios-internos/programa-corresponsabilidad-parental/bapr",
        name: "P. Corresponsabilidad Parental - Beca de Apoyo Preescolar",
        component: () => import("@/views/crafted/pages/intranet/Bapr.vue"),
      },
      {
        path: "/beneficios-internos/programa-corresponsabilidad-parental/bapa",
        name: "P. Corresponsabilidad Parental - Beca de Apoyo Parental",
        component: () => import("@/views/crafted/pages/intranet/Bapa.vue"),
      },
      {
        path: "/beneficios-internos/programa-corresponsabilidad-parental/pcp-documentos-generales",
        name: "P. Corresponsabilidad Parental - Documentos Generales",
        component: () =>
          import("@/views/crafted/pages/intranet/PCPDocumentosGenerales.vue"),
      },
      {
        path: "/beneficios-internos/programa-residencia-universitaria/beri",
        name: "Programa de Residencia Universitaria - Beca de Residencia Interna",
        component: () => import("@/views/crafted/pages/intranet/Beri.vue"),
      },
      {
        path: "/beneficios-internos/programa-residencia-universitaria/pru-documentos-generales",
        name: "Programa de Residencia Universitaria - Documentos Generales",
        component: () =>
          import("@/views/crafted/pages/intranet/PRUDocumentosGenerales.vue"),
      },
      {
        path: "/beneficios-internos/programa-residencia-universitaria/vru",
        name: "Programa de Residencia Universitaria - Vacante de Residencia Universitaria",
        component: () => import("@/views/crafted/pages/intranet/Vru.vue"),
      },
      {
        path: "/beneficios-internos/admision-especial/sipee",
        name: "Administion Especial - SIPEE",
        component: () => import("@/views/crafted/pages/intranet/Sipee.vue"),
      },
      {
        path: "/beneficios-internos/admision-especial/pace",
        name: "Administion Especial - PACE",
        component: () => import("@/views/crafted/pages/intranet/Pace.vue"),
      },
      {
        path: "/beneficios-externos/mineduc/postulacion-y-acreditacion",
        name: "Mineduc - Postulación y Acreditación",
        component: () =>
          import("@/views/crafted/pages/intranet/PostYAcred.vue"),
      },
      {
        path: "/beneficios-externos/mineduc/nuevas-asignaciones",
        name: "Mineduc - Nuevas Asignaciones",
        component: () =>
          import("@/views/crafted/pages/intranet/NuevasAsignaciones.vue"),
      },
      {
        path: "/beneficios-externos/mineduc/renovacion-beneficios",
        name: "Mineduc - Renovación Beneficios",
        component: () =>
          import("@/views/crafted/pages/intranet/RenovacionBeneficios.vue"),
      },
      {
        path: "/beneficios-externos/mineduc/mineduc-documentos-generales",
        name: "Mineduc - Documentos Generales",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/MineducDocumentosGenerales.vue"
          ),
      },
      {
        path: "/beneficios-externos/ingresa/licitaciones",
        name: "Ingresa - Licitaciones",
        component: () =>
          import("@/views/crafted/pages/intranet/Licitaciones.vue"),
      },
      {
        path: "/beneficios-externos/ingresa/renovantes",
        name: "Ingresa - Renovantes",
        component: () =>
          import("@/views/crafted/pages/intranet/Renovantes.vue"),
      },
      {
        path: "/beneficios-externos/junaeb/baes",
        name: "Junaeb - BAES",
        component: () => import("@/views/crafted/pages/intranet/Baes.vue"),
      },
      {
        path: "/beneficios-externos/junaeb/bpr",
        name: "Junaeb - Beca Presidente de la República",
        component: () => import("@/views/crafted/pages/intranet/Bpr.vue"),
      },
      {
        path: "/beneficios-externos/junaeb/bi",
        name: "Junaeb - Beca Indígena",
        component: () => import("@/views/crafted/pages/intranet/Bi.vue"),
      },
      {
        path: "/beneficios-externos/junaeb/breg",
        name: "Junaeb - Becas Regionales",
        component: () => import("@/views/crafted/pages/intranet/Breg.vue"),
      },
      /*
      {
        path: "/beneficios-externos/junaeb/bri",
        name: "bri",
        component: () => import("@/views/crafted/pages/intranet/Bri.vue"),
      },
      {
        path: "/beneficios-externos/junaeb/bit",
        name: "bit",
        component: () => import("@/views/crafted/pages/intranet/Bit.vue"),
      },
      {
        path: "/beneficios-externos/junaeb/pa",
        name: "pa",
        component: () => import("@/views/crafted/pages/intranet/Pa.vue"),
      },
      {
        path: "/beneficios-externos/junaeb/polimetales",
        name: "polimetales",
        component: () =>
        import("@/views/crafted/pages/intranet/Polimetales.vue"),
      },
      */
      {
        path: "/beneficios-externos/junaeb/bmvp",
        name: "Junaeb - Beca Melipilla Vive la U",
        component: () => import("@/views/crafted/pages/intranet/Bmvp.vue"),
      },
      {
        path: "/beneficios-externos/junaeb/bemes",
        name: "Junaeb - BMES",
        component: () => import("@/views/crafted/pages/intranet/Bemes.vue"),
      },
      {
        path: "/beneficios-externos/junaeb/junaeb-documentos-generales",
        name: "Junaeb - Documentos Generales",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/JunaebDocumentosGenerales.vue"
          ),
      },
      {
        path: "/beneficios-externos/tne",
        name: "TNE",
        component: () => import("@/views/crafted/pages/intranet/Tne.vue"),
      },
      {
        path: "/la-uinvita/actividades",
        name: "La U Invita - Actividades",
        component: () =>
          import("@/views/crafted/pages/intranet/Actividades.vue"),
      },
      {
        path: "/la-uinvita/participantes",
        name: "La U Invita - Participantes",
        component: () =>
          import("@/views/crafted/pages/intranet/Participantes.vue"),
      },
      {
        path: "/la-uinvita/sistematizacion/encuestas",
        name: "La U Invita - Encuestas",
        component: () => import("@/views/crafted/pages/intranet/Encuestas.vue"),
      },
      {
        path: "/la-uinvita/sistematizacion/informes",
        name: "La U Invita - Sistematización - Informes",
        component: () => import("@/views/crafted/pages/intranet/Informes.vue"),
      },
      {
        path: "/proyectos-estudiantiles/praz",
        name: "Proyectos Estudiantiles - Premio Azul",
        component: () => import("@/views/crafted/pages/intranet/Praz.vue"),
      },
      {
        path: "/proyectos-estudiantiles/datos-participacion",
        name: "Proyectos Estudiantiles - Datos de Participación",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/desarrollo-estudiantil/proyectos-estudiantiles/DatosParticipacion.vue"
          ),
      },
      {
        path: "/proyectos-estudiantiles/informes-gestion",
        name: "Proyectos Estudiantiles - Informes de Gestión",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/desarrollo-estudiantil/proyectos-estudiantiles/InformesGestion.vue"
          ),
      },
      {
        path: "/proyectos-estudiantiles/sistematizacion",
        name: "Proyectos Estudiantiles - Sistematización",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/desarrollo-estudiantil/proyectos-estudiantiles/Sistematizacion.vue"
          ),
      },
      {
        path: "/territorio-uchile/tu-datos-participacion",
        name: "Territorio UChile - Datos de participación",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/desarrollo-estudiantil/territorio-uchile/DatosParticipacion.vue"
          ),
      },
      {
        path: "/territorio-uchile/boletines-vida-universitaria",
        name: "Territorio UChile - Boletines para la vida universitaria",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/desarrollo-estudiantil/territorio-uchile/BoletinesParaLaVidaUniversitaria.vue"
          ),
      },
      {
        path: "/territorio-uchile/kits-metodologicos",
        name: "Territorio UChile - Kits metodológicos",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/desarrollo-estudiantil/territorio-uchile/KitsMetodologicos.vue"
          ),
      },
      {
        path: "/territorio-uchile/pasantias",
        name: "Territorio UChile - Pasantías",
        component: () => import("@/views/crafted/pages/intranet/Pasantias.vue"),
      },
      {
        path: "/desarrollo-estudiantil/organizaciones-estudiantiles",
        name: "Organizaciones estudiantiles",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/desarrollo-estudiantil/Organizaciones-Estudiantiles.vue"
          ),
      },
      {
        path: "/desarrollo-estudiantil/convenios-alianzas",
        name: "Convenios y Alianzas",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/desarrollo-estudiantil/Convenios-Alianzas.vue"
          ),
      },
      {
        path: "/desarrollo-estudiantil/investigacion",
        name: "Investigación",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/desarrollo-estudiantil/investigacion.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/pdi-informes",
        name: "Convivencia Universitaria - Informes",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/programa-dialogos-intergeneracionales/Informes.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/pdi-videos",
        name: "Convivencia Universitaria - Videos",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/programa-dialogos-intergeneracionales/Videos.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/pdi-notas-prensa",
        name: "Convivencia Universitaria - Notas de Prensa",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/programa-dialogos-intergeneracionales/Notas-Prensa.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/pdi-fotos",
        name: "Convivencia Universitaria - Fotos",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/programa-dialogos-intergeneracionales/Fotos.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/pdi-intervenciones",
        name: "Convivencia Universitaria - Programa de Diálogos Intergeneracionales - Intervenciones",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/programa-dialogos-intergeneracionales/Intervenciones.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/iic-documentos-investigacion",
        name: "Convivencia Universitaria - Documentos de Investigación",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/investigacion-intervencion-convivencia/Documentos-Investigacion.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/iic-presentacion-seminarios",
        name: "Convivencia Universitaria - Presentación Seminarios",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/investigacion-intervencion-convivencia/Presentacion-Seminarios.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/iic-noticias",
        name: "Convivencia Universitaria - Noticias",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/investigacion-intervencion-convivencia/Noticias.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/iic-seminarios-convivencia",
        name: "Convivencia Universitaria - Seminarios de Convivencia",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/investigacion-intervencion-convivencia/Seminarios-Convivencia.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/iic-diagnosticos-convivencia",
        name: "Convivencia Universitaria - Diagnósticos de Convivencia",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/investigacion-intervencion-convivencia/Diagnosticos-Convivencia.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/fec-sensibilizacion",
        name: "Convivencia Universitaria - Sensibilización",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/formacion-en-convivencia/Sensibilizacion.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/fec-talleres",
        name: "Convivencia Universitaria - Talleres",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/formacion-en-convivencia/Talleres.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/fec-ferias",
        name: "Convivencia Universitaria - Ferias",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/formacion-en-convivencia/Ferias.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/fec-asesorias",
        name: "Convivencia Universitaria - Asesorías",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/formacion-en-convivencia/Asesorias.vue"
          ),
      },
      {
        path: "/convivencia-universitaria/fec-intervenciones",
        name: "Convivencia Universitaria - Intervenciones",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/convivencia-universitaria/formacion-en-convivencia/Intervenciones.vue"
          ),
      },
      {
        path: "/mediacion-estudiantil/caja-de-herramientas/me-analisis-de-conflictos",
        name: "Mediación Estudiantil - Análisis de Conflictos",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/mediacion-estudiantil/caja-de-herramientas/AnalisisDeConflictos.vue"
          ),
      },
      {
        path: "/mediacion-estudiantil/caja-de-herramientas/me-enfoques-y-modelos",
        name: "Mediación Estudiantil - Enfoques y Modelos de Mediación",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/mediacion-estudiantil/caja-de-herramientas/EnfoquesYModelos.vue"
          ),
      },
      {
        path: "/mediacion-estudiantil/caja-de-herramientas/me-proceso-mediacion-estudiantil",
        name: "Mediación Estudiantil - Proceso mediación estudiantil",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/mediacion-estudiantil/caja-de-herramientas/ProcesoMediacionEstudiantil.vue"
          ),
      },
      {
        path: "/mediacion-estudiantil/caja-de-herramientas/me-documentos-complementarios",
        name: "Mediación Estudiantil - Documentos complementarios",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/mediacion-estudiantil/caja-de-herramientas/DocumentosComplementarios.vue"
          ),
      },
      {
        path: "/mediacion-estudiantil/me-informes",
        name: "Mediación Estudiantil - Informes",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/mediacion-estudiantil/Informes.vue"
          ),
      },
      {
        path: "/mediacion-estudiantil/me-jornadas-trabajo",
        name: "Mediación Estudiantil - Jornadas de trabajo",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/mediacion-estudiantil/JornadasTrabajo.vue"
          ),
      },
      {
        path: "/mediacion-estudiantil/kits-para-feria/me-material-para-imprimir",
        name: "Mediación Estudiantil - Material para imprimir",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/mediacion-estudiantil/kits-para-feria/MaterialParaImprimir.vue"
          ),
      },
      {
        path: "/equidad-inclusion/ei-material",
        name: "Subdirección de Equidad e Inclusión",
        component: () =>
          import(
            "@/views/crafted/pages/intranet/equidad-inclusion/Material.vue"
          ),
      },
      {
        path: "/docs-general",
        name: "Documentos Generales",
        component: () =>
          import("@/views/crafted/pages/intranet/GestionInstitucional.vue"),
      },
      {
        path: "/formularios",
        name: "Formularios",
        component: () =>
          import("@/views/crafted/pages/intranet/Formularios.vue"),
      },
      {
        path: "/vistas",
        name: "Vistas",
        component: () => import("@/views/crafted/pages/intranet/Vistas.vue"),
      },
      {
        path: "/reportes-udatos",
        name: "Reportes UDatos",
        component: () =>
          import("@/views/crafted/pages/intranet/ReportesUDatos.vue"),
      },
      // {
      //   path: "/beneficios-internos",
      //   name: "Beneficios Internos",
      //   component: () =>
      //     import("@/components/page-layouts/BeneficiosInternos.vue"),
      //   children: [
      //     {
      //       path: "/arancel",
      //       name: "Beneficios Internos - Arancel",
      //       component: () => import("@/views/crafted/pages/intranet/Buch.vue"),
      //       props: true,
      //     },
      //   ],
      // },
      {
        path: "/admin",
        name: "Administración",
        component: () => import("@/components/page-layouts/Admin.vue"),
        children: [
          {
            path: "/admin/news/create",
            name: "Administrar Noticias - Crear Noticia",
            component: () =>
              import(
                "@/views/crafted/pages/intranet/admin/news/NewsCreate.vue"
              ),
            props: true,
          },
          {
            path: "/admin/news/edit/:id",
            name: "Administrar Noticias - Editar Noticia",
            component: () =>
              import("@/views/crafted/pages/intranet/admin/news/NewsEdit.vue"),
          },
          {
            path: "/admin/news",
            name: "Administrar Noticias - Listado de Noticias",
            component: () =>
              import("@/views/crafted/pages/intranet/admin/news/NewsList.vue"),
          },
          {
            path: "/admin/posts/create",
            name: "Administrar Documentos - Crear Documento",
            component: () =>
              import(
                "@/views/crafted/pages/intranet/admin/posts/PostsCreate.vue"
              ),
            props: true,
          },
          {
            path: "/admin/posts/edit/:id",
            name: "Administrar Documentos - Editar Documento",
            component: () =>
              import(
                "@/views/crafted/pages/intranet/admin/posts/PostsEdit.vue"
              ),
          },
          {
            path: "/admin/posts",
            name: "Administrar Documentos - Listado de Documentos",
            component: () =>
              import(
                "@/views/crafted/pages/intranet/admin/posts/PostsList.vue"
              ),
          },
        ],
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/components/page-layouts/Auth.vue"),
    children: [
      {
        path: "/sign-in",
        name: "Iniciar Sesión",
        component: () =>
          import("@/views/crafted/authentication/basic-flow/SignInView.vue"),
      },
    ],
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/crafted/authentication/Error404.vue"),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // reset config to initial state
  //store.commit(Mutations.RESET_LAYOUT_CONFIG);
  document.title = `Gestión DIRBDE - ${String(to.name)}`;
  next();
  store.dispatch(Actions.VERIFY_AUTH);

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
